import { useEffect } from 'react'

import withRouter from 'utils/withRouter'
import storage from 'utils/storage'
import { trackPage } from 'utils/analytics'

const AnalyticsWrapper = props => {
  const { location } = props
  useEffect(() => { storage.setCID() }, [])
  useEffect(() => {
    const path = location.pathname || window.location.pathname
    const search = location.search || window.location.search
    trackPage(path + search)
  }, [location.pathname, location.search])
  return (<>{ props.children }</>)
}

export default withRouter(AnalyticsWrapper)
